// extracted by mini-css-extract-plugin
export default {"header":"Header_header__406k1","main-image":"Header_main-image__aN62i"};